import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function AssignBackupItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    return (
        <ContextMenuItem
            dataPendoId="menu-item-assign-backup"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                if (clickParams.eventId) {
                    drawerControls.open({
                        type: 'manage-units',
                        props: { eventId: clickParams.eventId },
                    });
                }
            }}
        />
    );
}
